/**
 * AuthModal - Modal container for web authentication
 */
import React from 'react';
import { Modal } from 'antd';
import { useAuthContext } from '../../context/AuthContext';
import AuthContent from './AuthContent';

function AuthModal() {
  const { isOpen, closeAuth, loading } = useAuthContext();
  
  return (
    <Modal
      open={isOpen}
      onCancel={closeAuth}
      footer={null}
      centered
      width={440}
      destroyOnClose
      closable={!loading}
      maskClosable={!loading}
      className="auth-modal"
      styles={{
        content: {
          padding: 0,
          borderRadius: 16,
          overflow: 'hidden',
        },
        mask: {
          backgroundColor: 'rgba(0, 0, 0, 0.45)',
        },
      }}
    >
      {/* Close button */}
      <button
        onClick={closeAuth}
        disabled={loading}
        className="absolute right-4 top-4 z-10 p-1 rounded-full hover:bg-gray-100 transition-colors disabled:opacity-50"
        aria-label="Close"
      >
      </button>
      
      <AuthContent />
    </Modal>
  );
}

export default AuthModal;
